// cart-recommendations.js
class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.isUpdating = false;
    this.lastUpdateTime = 0;
    this.updateDelay = 1000;
    this.setupEventListeners();
    this.fetchRecommendations();
  }

  setupEventListeners() {
    // Cart changes
    document.addEventListener('cart:change', () => this.debouncedFetchRecommendations());
    document.addEventListener('cart:open', () => this.debouncedFetchRecommendations());
    document.addEventListener('cart:update', () => this.debouncedFetchRecommendations());

    // Remove button clicks
    document.addEventListener('click', (event) => {
      const removeButton = event.target.closest('cart-remove-button');
      if (removeButton) {
        this.debouncedFetchRecommendations(750);
      }
    });
  }

  updateTitleVisibility() {
    const title = this.querySelector('.title.h4');
    const navigationList = this.querySelector('.mini-cart__navigation');
    const hasProducts = navigationList && navigationList.children.length > 0;
    
    if (title) {
      title.style.display = hasProducts ? '' : 'none';
    }
  }

  debouncedFetchRecommendations(delay = 300) {
    const now = Date.now();
    if (this.isUpdating || (now - this.lastUpdateTime) < this.updateDelay) {
      return;
    }
    
    clearTimeout(this.updateTimeout);
    this.updateTimeout = setTimeout(() => {
      this.fetchRecommendations();
    }, delay);
  }

  fetchRecommendations() {
    if (this.isUpdating) return;

    const url = this.dataset.url;
    if (!url) return;

    this.isUpdating = true;
    this.lastUpdateTime = Date.now();

    const timestamp = new Date().getTime();
    const updatedUrl = `${url}${url.includes('?') ? '&' : '?'}t=${timestamp}`;

    fetch(updatedUrl)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          const newNavigation = recommendations.querySelector('.mini-cart__navigation');
          const currentNavigation = this.querySelector('.mini-cart__navigation');
          
          if (newNavigation && currentNavigation && 
              currentNavigation.innerHTML !== newNavigation.innerHTML) {
            currentNavigation.innerHTML = newNavigation.innerHTML;
            this.updateTitleVisibility();
          }
        }
      })
      .catch(e => console.error('Error updating recommendations:', e))
      .finally(() => {
        this.isUpdating = false;
      });
  }

  disconnectedCallback() {
    clearTimeout(this.updateTimeout);
  }
}

customElements.define('cart-recommendations', CartRecommendations);